var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8038_212545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0038 31.625C22.9686 31.625 22.1991 32.4641 22.1991 33.5C22.1991 34.5352 23.0389 35.375 24.0038 35.375C25.0389 35.375 25.8084 34.5352 25.8084 33.5C25.8788 32.4609 25.0428 31.625 24.0038 31.625ZM24.0038 28.5C24.6946 28.5 25.1834 27.9409 25.1834 27.25V16C25.1834 15.3091 24.6245 14.75 24.0038 14.75C23.383 14.75 22.7538 15.3125 22.7538 16V27.25C22.7538 27.9375 23.3163 28.5 24.0038 28.5ZM43.4022 34.5391L27.7928 8.13906C27.0038 6.80234 25.5819 6.00234 24.0038 6C22.4256 6 21.0116 6.79844 20.2147 8.1375L4.5975 34.5437C3.81235 35.8695 3.80063 37.4609 4.56455 38.8016C5.35453 40.1797 6.7811 41 8.38656 41H39.6288C41.2311 41 42.6561 40.1773 43.442 38.7992C44.2069 37.4609 44.1913 35.8672 43.4022 34.5391ZM41.1991 37.4922C40.9334 38.1484 40.3163 38.5 39.5584 38.5H8.38656C7.69078 38.5 7.07563 38.1497 6.73969 37.5625C6.4211 37.0034 6.42602 36.3672 6.75189 35.8156L22.3709 9.41094C22.7069 8.84063 23.3163 8.5 24.0038 8.5C24.6885 8.50122 25.2975 8.84055 25.6334 9.40937L41.2506 35.8156C41.5116 36.3672 41.5897 37 41.1991 37.4922Z",
    fill: "#E86417"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8038_212545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.c5229098f88b4e003dde0c44d4464ad5.svg";
export { ForwardRef as ReactComponent };